import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import { SUGGESTION_BOX_QUERY } from './Query/SuggestionBoxQuery';
import DropdownItem from "react-bootstrap/DropdownItem";
import IconWrapper from '../Icons/IconWrapper';
import DownArrow from '../Icons/Arrow/DownArrow';
import { setSearchString } from '../../../actions/search';
import { connect } from "react-redux";
import { Black, WerfenColor5 } from "../../Constants/ColorChart";
import { useQuery } from "@apollo/client";

/*
 *  @Description:   Stateless component that renders a hint of one or more SuggestionItems.
 */

const StyledDiv = styled.div`
    position: relative;
`;

const StyledWrap = styled.div`
    &.open .dropdown-menu{
        display: block!important
    }
    .dropdown-menu{
        width: 100%;
        border-radius: 0px;
        box-shadow: 0 0 0 transparent;
        & > li > a {
            font-size:15pt!important;
            padding:10px 40px 10px 20px!important;
            overflow: hidden;
            text-overflow: ellipsis;
            @media (max-width: 992px){
                font-size: 12pt!important;
                padding-right: 40px !important;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &:hover {
                background: ${ WerfenColor5 }
            }
            &:focus {
                color: ${ Black }
            }
        }
        & > li + div {
            float: right;
            transform: translate(-5px,-35px) rotate(135deg);
            color: ${ Black };
            opacity: 0.85;
            height: 30px;
            width: 30px;
            margin-top: -5px;
            margin-bottom: -20px;
            cursor: pointer
            @media (max-width: 992px){
                height: 40px;
                width: 40px;
                margin-bottom: -36px;
            }
            &:hover {
                opacity: 1;
                cursor: pointer;
            }
        }
    }
`;

const SuggestionBox = ( props ) => {
    const {
        history,
        setSearchString,
        suggestString,
        BUfilterArray,
        DfilterArray,
        FEfilterArray,
        TypeFilterArray,
        DateFilterArray,
        showAutoSuggestPanel,
        isNetworkAvailable,
        // isServerReachable
    } = props;
    const canConnect = isNetworkAvailable //&& isServerReachable;
    const [ isVisible, setIsVisible ] = useState ( false );

    useEffect(()=>{
        setIsVisible(showAutoSuggestPanel)
    },[showAutoSuggestPanel])

    const createMarkup = ( html ) => {
        return { __html: decodeURIComponent( html ) };
    }

    const stripMarkup = ( html ) => {
        const div = document.createElement( "div" );
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }

    const { loading, data, error } = useQuery( SUGGESTION_BOX_QUERY, {
        variables: {
            "query_string": suggestString,
            "business_units": BUfilterArray,
            "departments": DfilterArray,
            "file_extensions": FEfilterArray,
            "types": TypeFilterArray,
            "dates": DateFilterArray,
            "limit": 10
        },
        fetchPolicy: "no-cache",
        notifyOnNetworkStatusChange: true,
        partialRefetch: true,
        returnPartialData: true,
        errorPolicy: "ignore",
        skip: suggestString.trim() === ""

    } )

    let output;
    if ( loading ) {
        output = <li><DropdownItem key="loading">Loading...</DropdownItem></li>
    }

    if ( error ) {
        if ( error.networkError || error.networkError.statusCode === 403 ) {
            output = <DropdownItem
                key="error">Please check your network connection</DropdownItem>
        } else {
            output = <DropdownItem
                key="error">{ JSON.stringify( error.message ) }</DropdownItem>
        }

        if ( !canConnect ) {
            output = <DropdownItem key="error"> No network available </DropdownItem>
        }
    }

    if ( !loading && (!data || !data.searchSuggestions || !data.searchSuggestions[0].length) ) {
        output = <li><DropdownItem
            key="no-results">No suggestions found.</DropdownItem></li>
    }
    if ( !loading && !error && data && data.searchSuggestions && data.searchSuggestions[0].length ) {
        const suggestionBoxArray = data.searchSuggestions[0]

        output = suggestionBoxArray.map( ( item, index ) => {

            return (
                <React.Fragment key={ index }>
                    <li>
                        <DropdownItem
                            key={ index }
                            className={ "searchSuggestionItem searchElement" }
                            dangerouslySetInnerHTML={ createMarkup( item ) }
                            onClick={ () => {
                                const query = stripMarkup( item )
                                document.querySelectorAll( ".searchElement.searchBarInput" )[0].value = query;
                                props.updateSearchString( query );
                                setSearchString( query, true );
                                history.push( "/search/" + query );
                            } }/>
                    </li>
                    <div
                        onClick={ () => {
                            const query = stripMarkup( item );
                            props.updateSearchString(query);
                        } }
                        className={ "searchElement" }>
                        <IconWrapper
                            color={ Black }
                            iconStyle="stroke-width: 8px; margin-left: 10px; margin-top: 10px; width: 20px; height:20px; position: absolute;"
                            Icon={ DownArrow }
                        />
                    </div>
                </React.Fragment>
            )
        } )
    }

    return (
        <StyledDiv id="suggestions">
            <div>
                <StyledWrap className={ isVisible ? "open" : "" }>
                    <ul className="dropdown-menu">
                        { output }
                    </ul>
                </StyledWrap>
            </div>
        </StyledDiv>
    )
}

const mapStateToProps = ( state ) => (
    {
        BUfilterArray: state.filters.BUfilterArray,
        DfilterArray: state.filters.DfilterArray,
        FEfilterArray: state.filters.FEfilterArray,
        TypeFilterArray: state.filters.TypeFilterArray,
        DateFilterArray: state.filters.DateFilterArray,
        searchString: state.search.searchString,
        suggestString: state.search.suggestString,
        showAutoSuggestPanel: state.ui.showAutoSuggestPanel,
        isNetworkAvailable: state.sensors.isNetworkAvailable,
        isServerReachable: state.sensors.isServerReachable,
    });

export default connect( mapStateToProps, { setSearchString } )( SuggestionBox );


